var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatingCall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.013,
    height: 12.205,
    viewBox: "0 0 20.013 12.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.631 1.049a.656.656 0 00-.7.1L15.06 4.482v-3.8a.68.68 0 00-.679-.679H.679A.68.68 0 000 .679v10.846a.68.68 0 00.679.679h13.7a.68.68 0 00.68-.679v-3.8l3.871 3.333a.655.655 0 001.083-.5V1.645a.656.656 0 00-.382-.596z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingCall1);
export default __webpack_public_path__ + "static/media/floating-call-1.6ccee508.svg";
export { ForwardRef as ReactComponent };